import React from 'react';

import classNames from 'classnames';

import { EXCEPTION_CELL_CLASS, OpenRowButton, orNotSet } from '../HomeSection';

import { moneyFigure, StatusBadge } from './rowBadges';

import { formatDateWithYear } from 'Helpers/dateTimeService';

import Badge from 'CommonComponents/Badge';

/**
 * The user's procurements, in the Procurement Plan screen's own columns.
 *
 * `overdue_to_market` is read from the row rather than recomputed from the date
 * beside it. It also depends on the item's status, and it was decided against
 * midnight in the user's own timezone, which the browser cannot reproduce.
 *
 * The rows arrive ordered, overdue first; nothing is re-sorted here. Per-row
 * values only — there is no total under the Value column, and there is nowhere
 * in the payload for one to come from.
 */
export default function ProcurementSectionTable({ rows = [], onRowClick }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>{$t('Name')}</th>
                        <th className="tw-w-40">{$t('Value')}</th>
                        <th className="tw-w-40">{$t('Status')}</th>
                        <th className="tw-w-36">{$t('Scope to Market')}</th>
                        <th className="tw-w-36">{$t('Contract Award Date')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.id} onClick={() => onRowClick?.(row)} className="tw-cursor-pointer">
                            <td className={classNames({ [EXCEPTION_CELL_CLASS]: row.overdue_to_market })}>
                                <OpenRowButton onClick={() => onRowClick?.(row)} label={$t('Open {{item}}', { item: row.name })}>
                                    {row.name}
                                </OpenRowButton>
                            </td>
                            <td className="inbud-numeric-cell">{moneyFigure(row.value)}</td>
                            <td>
                                <StatusBadge status={row.status} />
                            </td>
                            <td className="inbud-date-cell">
                                {orNotSet(row.scope_to_market_date && formatDateWithYear(row.scope_to_market_date))}
                                {!!row.overdue_to_market && (
                                    <Badge variant="danger" className="tw-ms-2">
                                        {$t('Overdue')}
                                    </Badge>
                                )}
                            </td>
                            <td className="inbud-date-cell">{orNotSet(row.contract_award_date && formatDateWithYear(row.contract_award_date))}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
